import { HttpException } from "http-repository-cache";
import AuthRepository from "core/authUser/auth/repositories/AuthRepository";
import AuthData from "core/authUser/auth/entities/AuthData";
import {
  ApiLoginRequest,
  ApiLoginResponse,
  ApiResetPasswordRequest,
} from "core/authUser/auth/entities/ApiAuthData";
import { AuthDataMapper } from "core/authUser/auth/mappers/AuthDataMapper";
import {
  loginUrl,
  logoutUrl,
  resetPasswordUrl,
} from "details/data/backend/rest/api/authBackendEndpoints/authBackendEndpoints";
import handleRequestError from "../../http/services/handleRequestError/handleRequestError";
import { ApiResponse } from "../../api/types/ApiResponse";
import {
  executeRequest,
  executeVoidRequest,
} from "../../http/services/executeRequest/executeRequest";
import {
  RepositoryResult,
  RepositoryResultFactory,
} from "core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";

export default class AuthRepositoryBackend implements AuthRepository {
  constructor(private readonly httpClient: HttpClient) {}

  login(
    email: string,
    password: string,
  ): Promise<RepositoryResult<AuthData>> {
    // Transform internal format to API format
    const apiRequest: ApiLoginRequest = AuthDataMapper.toApiLoginRequest(
      email,
      password,
    );

    return executeRequest(
      () =>
        this.httpClient.post<ApiResponse<ApiLoginResponse>, ApiLoginRequest>({
          url: loginUrl(),
          body: apiRequest,
          withAuth: false,
        }),
      (data) => AuthDataMapper.fromApiLoginResponse(email, data),
    );
  }

  async logout(token: string): Promise<RepositoryResult<void>> {
    try {
      await this.httpClient.get<void>({
        url: logoutUrl(token),
        withAuth: true,
      });

      return RepositoryResultFactory.success(undefined);
    } catch (error: unknown) {
      return RepositoryResultFactory.error(
        handleRequestError(
          error as ApiResponse<unknown> | HttpException<unknown, unknown>,
        ),
      );
    }
  }

  resetPassword(
    body: ApiResetPasswordRequest,
  ): Promise<RepositoryResult<void>> {
    return executeVoidRequest(() =>
      this.httpClient.patch<ApiResponse<null>, ApiResetPasswordRequest>({
        url: resetPasswordUrl(),
        body,
        withAuth: false,
      }),
    );
  }
}
